module.exports = "/fonts/vendor/@fontsource/roboto/files/roboto-vietnamese-500-normal.woff2?d8642a3d1d4ef6179644843ecacc53b6";